import { render, staticRenderFns } from "./MainTableV2.vue?vue&type=template&id=2e5b675f&"
import script from "./MainTableV2.vue?vue&type=script&lang=js&"
export * from "./MainTableV2.vue?vue&type=script&lang=js&"
import style0 from "./MainTableV2.vue?vue&type=style&index=0&id=2e5b675f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports